import http from '@/services/http'

export default {
  install: (app) => {
    app.provide('http', http)
  }
}
